import { COLOR_PALETTE } from 'constants/ui';

// done/working/failed are saturated hues that read on both themes. pending/cancelled are light grays
// that would leak near-white on the dark canvas — resolve those per-mode against the palette.
const STEP_STATE_COLORS = {
  done: COLOR_PALETTE.GREEN[6],
  working: COLOR_PALETTE.BLUE[6],
  failed: COLOR_PALETTE.RED[6],
  attention: COLOR_PALETTE.ORANGE[6],
};

const resolveBarColor = (state, palette) => {
  if (STEP_STATE_COLORS[state]) {
    return STEP_STATE_COLORS[state];
  }

  if (state === 'cancelled') {
    return palette.mode === 'dark' ? 'rgba(255,255,255,0.28)' : COLOR_PALETTE.GRAY[5];
  }

  return palette.mode === 'dark' ? 'rgba(255,255,255,0.18)' : COLOR_PALETTE.GRAY[4];
};

export const containerStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '3px',
};

export const getBarStyles = state => ({
  width: '14px',
  height: '6px',
  borderRadius: '2px',
  backgroundColor: ({ palette }) => resolveBarColor(state, palette),
});
